import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { TID } from '../constants/testIds';
import NewsletterForm from '../components/common/NewsletterForm';

export default function InsightDetail() {
    const { slug } = useParams();
    const { data: a, isLoading } = useQuery({
        queryKey: ['article', slug],
        queryFn: async () => (await api.get(`/articles/${slug}`)).data,
    });

    if (isLoading || !a) return <div className="max-w-[900px] mx-auto px-6 py-20 text-neutral-500">Loading…</div>;

    return (
        <article>
            <div className="max-w-[900px] mx-auto px-6 lg:px-10 pt-16 pb-8">
                <div className="overline">{a.category} · {a.read_min} min read</div>
                <h1 className="font-editorial text-[44px] lg:text-[64px] tracking-editorial mt-6 leading-[1.02]">{a.title}</h1>
                <div className="mt-6 font-editorial text-[20px] italic text-neutral-600 leading-relaxed">{a.dek}</div>
                <div className="mt-8 flex items-center gap-4 text-[13px] text-neutral-500">
                    <span>{a.author}</span>
                    <span className="w-1 h-1 bg-neutral-300 rounded-full" />
                    <span className="font-mono-data">{a.published_at}</span>
                </div>
            </div>
            <div className="border-t border-b border-neutral-200 bg-neutral-100">
                <div className="max-w-[1200px] mx-auto aspect-[21/9] overflow-hidden">
                    <img src={a.hero} alt={a.title} className="w-full h-full object-cover" />
                </div>
            </div>
            <div className="max-w-[720px] mx-auto px-6 py-16" data-testid={TID.insights.articleBody}>
                <div className="prose max-w-none">
                    {a.body?.map((p, i) => (
                        <p key={i} className="text-[18px] leading-[1.72] mt-6 font-editorial text-neutral-800">{p}</p>
                    ))}
                </div>
                <div className="mt-12 flex flex-wrap gap-2">
                    {a.tags?.map((t) => (
                        <span key={t} className="text-[11px] uppercase tracking-[0.16em] px-2.5 py-1 border border-neutral-300">{t}</span>
                    ))}
                </div>
                <div className="mt-16 border-t border-neutral-200 pt-10">
                    <div className="overline">Continue reading</div>
                    <div className="font-editorial text-[24px] tracking-editorial mt-4 leading-tight">
                        Get one piece of analysis like this in your inbox every Sunday.
                    </div>
                    <div className="mt-6 max-w-md">
                        <NewsletterForm source={`article:${slug}`} />
                    </div>
                    <div className="mt-10">
                        <Link to="/insights" className="link-editorial text-[13.5px]">← All insights</Link>
                    </div>
                </div>
            </div>
        </article>
    );
}
